var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("收益明细模块管理")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收益明细背景图", prop: "imgUrl" } },
                    [
                      _c("upload", {
                        attrs: { name: "imgUrl", "img-url": _vm.form.imgUrl },
                        on: {
                          pictureAddress: function ($event) {
                            return _vm.onPictureAddress($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v("建议尺寸750px*400px PNG图片")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "温馨提示弹窗提示文案",
                        prop: "promptCopy",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 6 },
                          placeholder: "请输入",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.promptCopy,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "promptCopy", $$v)
                          },
                          expression: "form.promptCopy",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }